import gql from "graphql-tag";
const state = { all: {} };
import { formatDate_MDYHMS } from "@/_core/_helpers/_helpers";

const actions = {
  async getAll({ commit }, ctx) {
    commit("getAllRequest");
    await ctx.$apollo
      .query({
        query: gql`
          query($format: String, $user_id: Int, $refresh: String) {
            overview_choices(
              format: $format
              user_id: $user_id
              refresh: $refresh
            ) {
              overview_choices
              datamodel_choices
              analytics_choices
              markets_choices
              optimizer_choices
              hedges_choices
            }
          }
        `,
        variables: {
          format: "json",
          user_id: parseInt(localStorage.getItem("userData")),
          refresh: formatDate_MDYHMS(new Date())
        }
      })
      .then(data => {
        commit("getAllSuccess", data["data"]["overview_choices"]);
      })
      .catch(error => {
        console.log(error);
        commit("getAllFailure", error);
      });
  },
  logout({ commit }) {
    commit("logout");
  }
};

const mutations = {
  getAllRequest(state) {
    state.all = { loading: true };
  },
  getAllSuccess(state, user_preferences) {
    state.all = { items: user_preferences };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  logout(state) {
    state.all = null;
  }
};

export const user_preferences = {
  namespaced: true,
  state,
  actions,
  mutations
};
